import React from 'react';
import styled from 'styled-components';
import _ from 'lodash';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { SPACES } from 'common/constants/sizes';
import { Flex } from './base/layout-components';
import Text from './base/Text';

const Legend = styled.div`
  width: 1.5rem;
  height: 1rem;
  border-radius: 10px;
  background-color: ${({ color }) => color};
`;

const StackedAreaChart = props => {
  const { chartOptionsProp, reverseLegends, showLegend = true } = props;

  const chartOptions = {
    chart: {
      type: 'area'
    },
    title: {
      text: ''
    },
    plotOptions: {
      series: {
        borderWidth: 0,
        marker: {
          symbol: 'circle',
          enabled: false,
          radius: 1
        }
      },
      area: {
        pointPlacement: 'on',
        stacking: 'normal'
      },
      column: {
        stacking: 'normal'
      }
    },
    legend: {
      enabled: false
    },
    xAxis: {
      gridLineWidth: 1,
      tickInterval: 1
    },
    credits: {
      enabled: false
    },
    yAxis: {
      gridLineWidth: 1,
      title: {
        text: '',
        fontFamily: 'Outfit'
      }
    },
    tooltip: {
      useHTML: true,
      backgroundColor: 'none',
      borderWidth: 0,
      shadow: false,
      padding: 0,
      style: {
        fontFamily: 'Outfit, sans-serif'
      }
    },
    series: []
  };

  const options = _.merge(chartOptions, chartOptionsProp);
  const series = _.get(options, 'series', []);

  const Legends = series.map(({ color, name }, idx) => (
    <Flex pr='medium' items='center' key={idx}>
      <Legend color={color} />
      <Text pl={SPACES.small} color='abbey' size='medium'>
        {name}
      </Text>
    </Flex>
  ));

  return (
    <Flex direction='column' width='100%' height='100%'>
      {showLegend && (
        <Flex
          pb='small'
          data-testid='legend-data-test-id'
          {...(reverseLegends ? { direction: 'row-reverse' } : {})}
          {...(reverseLegends ? {} : { justify: 'flex-end' })}
          width='100%'
        >
          {Legends}
        </Flex>
      )}
      <HighchartsReact
        containerProps={{ style: { height: '100%', width: '100%' } }}
        highcharts={Highcharts}
        options={options}
      />
    </Flex>
  );
};

StackedAreaChart.propTypes = {};

export default StackedAreaChart;
